import script from "./BrandLogo.vue?vue&type=script&setup=true&lang=js"
export * from "./BrandLogo.vue?vue&type=script&setup=true&lang=js"

import "./BrandLogo.vue?vue&type=style&index=0&id=3f7106d5&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3f7106d5"]])

export default __exports__